import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { UserEntity } from './user.entity';

@Index('client__workd__user__fk_client__id_fk', ['fkClientId'], {})
@Index('client__workd__user__user__fk', ['workdUserId'], {})
@Entity('client__workd__user')
export class ClientWorkdUserEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'workd__user__id', unsigned: true })
	public workdUserId!: number;

	@Column('tinyint', { name: 'isClientActive', width: 1, default: () => "'0'" })
	public isClientActive!: boolean;

	@ManyToOne(() => ClientEntity, (client) => client.clientWorkdUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => UserEntity, (user) => user.clientWorkdUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'workd__user__id', referencedColumnName: 'id' }])
	public workdUser!: UserEntity;
}
